import { render } from "./TableAction.vue?vue&type=template&id=3dfe7690"
import script from "./TableAction.vue?vue&type=script&lang=js"
export * from "./TableAction.vue?vue&type=script&lang=js"
script.render = render

export default script